(function ($) {
  var elementorHookRegistered = false;
  var sliderSelector = '[data-subscription-slider]';
  var arrowIcon = '<svg width="88" height="88" viewBox="0 0 88 88" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="44" cy="44" r="44" fill="#39AFE1"/><path d="M25 43.6667H62.3333M62.3333 43.6667L43.6667 25M62.3333 43.6667L43.6667 62.3333" stroke="white" stroke-width="5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function initSlider($slider) {
    if (!$slider.length || !$.fn.slick || $slider.hasClass('slick-initialized')) {
      return;
    }

    $slider.slick({
      speed: 500,
      autoplay: false,
      autoplaySpeed: 5000,
      arrows: true,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      prevArrow: '<button type="button" class="slick-prev" aria-label="Precedent">' + arrowIcon + '</button>',
      nextArrow: '<button type="button" class="slick-next" aria-label="Suivant">' + arrowIcon + '</button>'
    });
  }

  function initSubscriptionSlider($scope) {
    var $sliders = $scope.is(sliderSelector) ? $scope : $scope.find(sliderSelector);

    $sliders.each(function () {
      initSlider($(this));
    });
  }

  function registerElementorHook() {
    if (
      elementorHookRegistered ||
      !window.elementorFrontend ||
      !window.elementorFrontend.hooks
    ) {
      return;
    }

    elementorHookRegistered = true;

    window.elementorFrontend.hooks.addAction(
      'frontend/element_ready/subscription-slider-section.default',
      initSubscriptionSlider
    );
  }

  $(window).on('elementor/frontend/init', registerElementorHook);

  $(function () {
    registerElementorHook();
    initSubscriptionSlider($(document));
  });
})(jQuery);
